/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ApiWebhookRequestStatus {
    NEW = 'NEW',
    RETRY = 'RETRY',
    SCHEDULED_RETRY = 'SCHEDULED_RETRY',
    FAILED = 'FAILED',
    COMPLETED = 'COMPLETED',
    CANCELLED = 'CANCELLED'
}


export function instanceOfApiWebhookRequestStatus(value: any): boolean {
    for (const key in ApiWebhookRequestStatus) {
        if (Object.prototype.hasOwnProperty.call(ApiWebhookRequestStatus, key)) {
            if (ApiWebhookRequestStatus[key as keyof typeof ApiWebhookRequestStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ApiWebhookRequestStatusFromJSON(json: any): ApiWebhookRequestStatus {
    return ApiWebhookRequestStatusFromJSONTyped(json, false);
}

export function ApiWebhookRequestStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiWebhookRequestStatus {
    return json as ApiWebhookRequestStatus;
}

export function ApiWebhookRequestStatusToJSON(value?: ApiWebhookRequestStatus | null): any {
    return value as any;
}

export function ApiWebhookRequestStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): ApiWebhookRequestStatus {
    return value as ApiWebhookRequestStatus;
}

